import axiosInstance from "../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const mainURL = `api/v1/purchase-app/purchase-order-request`;

//obtaining the paginated data
export const getMaterialRequest = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${mainURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllMaterialRequest = () => axiosInstance.get(`${mainURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageMaterialRequest = ({ number, rowsPerPage, search }) =>
  // axiosInstance.get(`${mainURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);
  axiosInstance.get(`${mainURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getMaterialRequestById = (id) => axiosInstance.get(`${mainURL}/retrieve/${id}`);

//creating function
export const createMaterialRequest = (body) => axiosInstance.post(`${mainURL}/create`, body);
//updating function
export const updateMaterialRequest = (id, body) => axiosInstance.patch(`${mainURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${mainURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};
